import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { State } from "common/state/State";
import { Unsubscribe } from "./Unsubscribe";
import { Button, ButtonCategory } from "common/button/Button";

interface IEmailMarketingUnsubscribePageUIProps {
  loading: boolean;
  primaryEmail: string;
  emsUserToken: string;
  unsubscribeDomain: string;
}
export const EmailMarketingUnsubscribePageUI: React.FC<
  IEmailMarketingUnsubscribePageUIProps
> = ({ loading, primaryEmail, emsUserToken, unsubscribeDomain }) => {
  const { t: translate } = useTranslation("email_marketing");
  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="50vh"
    >
      <State loading={loading}>
        <Box
          sx={{
            bgcolor: "grey.300",
            p: 2,
            borderRadius: 1,
            width: "30%",
            minWidth: "fit-content",
          }}
        >
          {isUnsubscribed ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="h5">
                {translate("email_unsubscribe.its_official")}
              </Typography>
              <Typography variant="body1">
                {translate("email_unsubscribe.unsubscribed_thanks")}
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="h5">
                {translate("email_unsubscribe.unsubscribe")}
              </Typography>
              <Typography variant="body1">
                {translate("email_unsubscribe.unsubscribe")}{" "}
                <Typography component="span" fontWeight="bold">
                  {primaryEmail}
                </Typography>{" "}
                from {unsubscribeDomain}.
              </Typography>
              <Unsubscribe
                emsUserToken={emsUserToken}
                onCompleted={() => setIsUnsubscribed(true)}
              >
                <Button
                  sx={{ alignSelf: "flex-start" }}
                  category={ButtonCategory.Secondary}
                >
                  {translate("email_unsubscribe.unsubscribe")}
                </Button>
              </Unsubscribe>
            </Box>
          )}
        </Box>
      </State>
    </Box>
  );
};
